const timeToMinutes = (timeStr: string) => {
  const [hours, minutes] = timeStr.split(':').map(Number)
  return hours * 60 + minutes
}

export const isOpenNow = (from: string, to: string) => {
  if (!from || !to) return
  const now = new Date()
  const currentMinutes = now.getHours() * 60 + now.getMinutes()

  const openMinutes = timeToMinutes(from)
  const closeMinutes = timeToMinutes(to)

  if (openMinutes < closeMinutes) {
    // Заведение открыто и закрывается в тот же день
    return currentMinutes >= openMinutes && currentMinutes < closeMinutes
  } else {
    // Заведение работает через полночь
    return currentMinutes >= openMinutes || currentMinutes < closeMinutes
  }
}
